<template>
  <div class="auth-page auth-page--login">
    <div class="auth-page__inner">
      <div class="auth-page__title">{{ $t("phone-call.title") }}</div>
      <div class="auth-page__sub-title">
        {{ $t("phone-call.sub_title", { phone: user.phone }) }}
      </div>
      <div class="auth-page__actions">
        <transparent-button
          :text="$t('phone-call.actions.previous-step')"
          @click="toLoginPage"
        ></transparent-button>
        <!--        <transparent-button-->
        <!--          :text="$t('phone-call.actions.retry-call')"-->
        <!--          @click="retryCall"-->
        <!--        ></transparent-button>-->
      </div>
    </div>
  </div>
</template>

<script>
import TransparentButton from "@/components/buttons/TransparentButton";
import { AuthApi } from "@/office/auth/auth-api";
import { mapGetters, mapState } from "vuex";
import {
  LOGIN_USER,
  SET_LOGIN_TRANSACTION_ID,
  SET_OTP_OPERATION_ID,
} from "@/store/action-types";
import useVuelidate from "@vuelidate/core";
import { helpers, minLength, required } from "@vuelidate/validators";
export default {
  name: "LoginPhoneCall",
  components: { TransparentButton },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      otpCode: "",
      vuelidateExternalResults: {
        otpCode: "",
      },
      phoneCallVerificationChannel: null,
    };
  },
  validations() {
    return {
      otpCode: {
        required: helpers.withMessage("otp_code_required", required),
        minLength: helpers.withMessage("otp_incorrect", minLength(4)),
      },
    };
  },
  computed: {
    ...mapState(["user", "wss"]),
    ...mapGetters(["loginTransactionId"]),
  },
  created() {
    if (!this.loginTransactionId) {
      return this.$router.push("/login");
    }

    this.handleChannel(this.loginTransactionId);
  },
  beforeDestroy() {
    if (this.phoneCallVerificationChannel) {
      this.phoneCallVerificationChannel.unsubscribe();
    }
  },
  methods: {
    toLoginPage() {
      this.$router.push("/login");
    },
    async loginCall() {
      new AuthApi()
        .finishCallLogin(this.user.phone, this.loginTransactionId)
        .then(async (r) => {
          await this.$store.dispatch(LOGIN_USER, {
            accessToken: r.data.access_token,
            phone: this.user.phone,
          });

          this.$router.push("/");
        })
        .catch(() => {
          this.$router.push("/login");
        });
    },
    handleChannel(transactionId) {
      if (this.phoneCallVerificationChannel) {
        this.phoneCallVerificationChannel.unsubscribe();
      }

      this.phoneCallVerificationChannel = this.wss.newSubscription(
        `${transactionId}`
      );
      this.phoneCallVerificationChannel.on("publication", async (msg) => {
        try {
          if (parseInt(msg.data.result) === 10) {
            await this.loginCall();
          } else {
            await this.$router.push("/login");
          }
        } catch (e) {
          console.error(e);
          await this.$router.push("/login");
        }
      });

      this.phoneCallVerificationChannel.subscribe();
    },
    retryCall() {
      new AuthApi()
        .startLogin(this.user.phone)
        .then(async (r) => {
          if (r.data.success) {
            await this.$store.dispatch(
              SET_OTP_OPERATION_ID,
              r.data.operation_id
            );

            if (r.data.is_phone_call) {
              await this.$store.dispatch(
                SET_LOGIN_TRANSACTION_ID,
                r.data.transaction_id
              );
              this.handleChannel(this.loginTransactionId);
            } else {
              this.$router.push("/login");
            }
          }
        })
        .catch(() => {
          this.$router.push("/login");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page {
  &__actions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 25px;
  }

  &__action {
    &--half {
      width: calc(50% - 5px);
    }
  }
}
</style>
